/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

import {
  HierarchicalTask,
  Resources,
  Task,
  TaskWorkflowSteps,
} from '@totem/components/ticketing/ticketing';

interface TaskContextProps {
  taskAction: string;
  taskActionExtras: string;
  onTaskAction: (newAction: string, extras: string) => void;
  rawTasks: Task[];
  tasks: Task[];
  taskHierarchy: HierarchicalTask[];
  taskMap: Map<number, HierarchicalTask>;
  resources: Resources;
  taskWorkflow: TaskWorkflowSteps;
  getTask: (taskNumber: number) => Task;
  getPreviousSibling: (task: Task) => Task;
  getPreviousSiblings: (task: Task) => Task[];
  getNextSibling: (task: Task) => Task;
  getNextSiblings: (task: Task) => Task[];
  getPreviousTask: (taskNumber: number) => HierarchicalTask | null;
  getNextTask: (taskNumber: number) => HierarchicalTask | null;
  getNextRootPosition: () => number;
  getNextPositionByParent: (taskNumber: number) => number;
  onTaskStatusChange: (status: string, task: Task) => void;
}

export default createContext<TaskContextProps>({
  taskAction: '',
  taskActionExtras: '',
  onTaskAction: () => {},
  rawTasks: [],
  tasks: [],
  taskHierarchy: [],
  taskMap: new Map<number, HierarchicalTask>(),
  resources: [],
  taskWorkflow: [],
  getTask: (taskNumber: number) => {
    return null;
  },
  getPreviousSibling: (task: Task) => {
    return null;
  },
  getPreviousSiblings: (task: Task) => {
    return [];
  },
  getNextSibling: (task: Task) => {
    return null;
  },
  getNextSiblings: (task: Task) => {
    return [];
  },
  getPreviousTask: (taskNumber: number) => {
    return null;
  },
  getNextTask: (taskNumber: number) => {
    return null;
  },
  getNextRootPosition: () => {
    return 0;
  },
  getNextPositionByParent: () => {
    return 0;
  },
  onTaskStatusChange: () => {},
});
